import React from 'react'

function Article2(props) {
  return (
    <article>
  <h3>Boats</h3>
  <p>Let's practice our first consonants:<br/> b: ب, th: ث and t: ت </p>
  <p>These letters look a bit like boats, don't they? </p>
  <p>They all bind in all three positions.</p>
  <p> Look at this: بثت </p>
  <p>That would be read as "bathat". Where do the "a"s come from?</p>
  <p>They're only implied. In Arabic, short vowels are rarely written out.</p>
  <p>Compare this to باثات which would be read as baathaat.</p>
    </article>
  )
}

export default Article2
